import { gql } from '@apollo/client';


export const GET_ORIS_QUERY = gql`
  query GET_ORIS_QUERY{
    getOris{
      id
      abbreviation
      inactive
      agencyType
      oriName
      tokenDisabled
      enableCarStop
      oriAddress {
        id
        name
        lat
        lng
      }
  }
}
`;
